<template>
<div style="position: relative;">

	<loading-indicator :loading="isLoading"></loading-indicator>

	<template v-if="!isLoading">

		<!-- page-heading -->
		<page-heading show="false" showBack="false" pageTitle="HEADER-BASE_DATA"></page-heading>

		<div class="columns is-multiline">

			<div class="column is-12 supplementPreview" v-if="isSupplement">

				<div class="heading">

					<img class="previewIcon lazy-img-fadein" v-lazy="mutationAsset.icon" />

					<div>
						<span>Ihr Paket</span>
						<h1><lang :labelKey="packageName" /></h1>
					</div>

				</div>

				<img class="previewImgBig lazy-img-fadein" v-lazy="mutationAsset.image" />

			</div>

			<!-- info text -->
			<div class="column is-12 has-text-centered">
				<div class="has-text-centered infoText" v-html="_infoText"></div>
			</div>

			<!-- MUTATIONS -->
			<div class="column is-12" v-if="package != null">

				<div class="box">

					<div class="boxHeader is-clearfix">
						<lang labelKey="APO_VIEW-TITLE-MUTATIONS"></lang>
					</div>



					<div :class="['mutations', { 'isSupplement': isSupplement }]">

						<template v-if="!isSupplement">

							<div v-for="(mutation, index) in mutations" :class="['mutation', mutation.name, mutation.name=='VOUCHER' ? (mutation.data2.id=='12' ? 'VOUCHER-12' : 'VOUCHER-6') : '', 'index-'+index]">

								<div class="columns">

									<div class="column is-narrow first">

										<div class="preview lazy-img-fadein" v-lazy:background-image="getAsset(mutation.data2)" @click="goToPage(mutation, index)"></div>

									</div>

									<div class="column second">

										<div>

											<div class="imageIcon" :style="{ 'backgroundImage': 'url(\'' + getIconAsset(mutation, index) + '\')' }">

											</div>

											<div class="title">
												<lang :labelKey="getMutationTitle(mutation, index)"></lang>
											</div>

											<div class="options">

												<span class="button" title="bearbeiten" @click="goToPage(mutation, index)">
													<span class="icon is-small">
														<i class="icon-ak-bearbeiten"></i>
													</span>
													{{ $t("CUSTOMIZATION-EDIT") }}
												</span>

												<a class="button" title="PDF Download" :href="getPDFDownloadUrl(mutation.data2)">
													<span class="icon is-small">
														<i class="icon-ak-download"></i>
													</span>
													{{ $t("CUSTOMIZATION-PDF_DOWNLOAD") }}
												</a>

											</div>

										</div>

									</div>

								</div>

							</div>

						</template>

						<template v-else>


							<div v-for="mut in mutationList" :class="['mutation', mut.name]">

								<template v-for="mutation in baseData.siteCatalogs[0].siteCatalogCustomizations" >
									<!--
									{{ mut.data.catalogPageCustomization }}<br>
									mutation type: {{ mutation.type }}<br><br>
									-->

									<template v-if="mut.data.catalogPageCustomization != null && mutation.type == mut.data.catalogPageCustomization">

										<div class="columns">

											<div class="column is-narrow first">

												<div :class="['preview lazy-img-fadein', mut.name]" v-lazy:background-image="getAsset(mutation)" @click="goToPage(mut)"></div>

											</div>

											<div class="column second">

												<div>

													<div class="title">
														<lang :labelKey="getMutationTitle(mut)"></lang>
													</div>

													<div class="options">

														<span class="button" title="bearbeiten" @click="goToPage(mut)">
															<span class="icon is-small">
																<i class="icon-ak-bearbeiten"></i>
															</span>
															{{ $t("CUSTOMIZATION-EDIT") }}
														</span>

														<a v-if="mutation.preview && mutation.preview.filename != null" class="button" title="PDF Download" :download="getPDFDownloadName(mutation)" :href="getPDFDownloadUrl(mutation.preview)">
															<span class="icon is-small">
																<i class="icon-ak-download"></i>
															</span>
															{{ $t("CUSTOMIZATION-PDF_DOWNLOAD") }}
														</a>

													</div>
												</div>

											</div>
										</div>

									</template>

								</template>

							</div>


							<div class="mutation VOUCHER VOUCHER-6" v-if="baseData.siteCatalogs[0].voucherPreview != null || baseData.siteCatalogs[0].voucherBackPreview != null">

								<div class="columns">

									<div class="column is-narrow first">

										<template v-if="baseData.siteCatalogs[0].voucherPreview && baseData.siteCatalogs[0].voucherPreview.path != null">
											<div class="preview lazy-img-fadein" v-lazy:background-image="getAsset({ id: '', preview: baseData.siteCatalogs[0].voucherPreview })" @click="goToPage({ name: 'VOUCHERS'})"></div>
										</template>

										<template v-if="baseData.siteCatalogs[0].voucherBackPreview && baseData.siteCatalogs[0].voucherBackPreview.path != null">
											<div class="preview lazy-img-fadein" v-lazy:background-image="getAsset({ id: '', preview: baseData.siteCatalogs[0].voucherBackPreview })" @click="goToPage({ name: 'VOUCHERS'})"></div>
										</template>

									</div>

									<div class="column second">

										<div>
											<div class="title">
												<lang labelKey="APO_VIEW-CUSTOMIZATION-TITLE-SUP-VOUCHERS"></lang>
											</div>

											<div class="options">


												<span class="button" title="bearbeiten" @click="goToPage({ name: 'VOUCHERS'})">
													<span class="icon is-small">
														<i class="icon-ak-bearbeiten"></i>
													</span>
													{{ $t("CUSTOMIZATION-EDIT") }}
												</span>

												<template v-if="baseData.siteCatalogs[0].voucherPreview && baseData.siteCatalogs[0].voucherPreview.path != null">
													<a class="button" title="PDF Download" :download="baseData.extRef+'-gutscheine-1.pdf'" :href="getPdfDownloadUrlVoucher('front')">
														<span class="icon is-small">
															<i class="icon-ak-download"></i>
														</span>
														{{ $t("CUSTOMIZATION-PDF_DOWNLOAD_VOUCHER_FRONT") }}
													</a>
												</template>

												<template v-if="baseData.siteCatalogs[0].voucherBackPreview && baseData.siteCatalogs[0].voucherBackPreview.path != null">
													<a class="button" title="PDF Download" :download="baseData.extRef+'-gutscheine-2.pdf'" :href="getPdfDownloadUrlVoucher('back')">
														<span class="icon is-small">
															<i class="icon-ak-download"></i>
														</span>
														{{ $t("CUSTOMIZATION-PDF_DOWNLOAD_VOUCHER_BACK") }}
													</a>
												</template>


											</div>

										</div>

									</div>

								</div>


							</div>


						</template>

					</div>


				</div>

			</div>


			<!-- BASE DATA -->
			<div class="column is-12">

				<div class="box myData">

					<div class="boxHeader">
						<!-- <lang labelKey="APO_VIEW-TITLE-MY_DATA"></lang> -->

					</div>

					<div class="columns is-12 is-multiline">
						<!--
						<div class="column is-4">

							<div v-if="baseData.logoAsset != null" class="logoContainer">
								<img class="lazy-img-fadein" v-lazy="logoUrl" />
							</div>

							<div><strong>{{ baseData.name }}</strong></div>
							<div v-if="baseData.contactPerson != null && baseData.contactPerson.fullName != ''">{{ baseData.contactPerson.fullName }}</div>
							<div>{{ baseData.address }}</div>
							<div>{{ baseData.zipcode }} {{ baseData.city }}</div>

							<br />

							<div class="contactData">
								<div v-if="baseData.phone"><span>Tel:</span> {{ baseData.phone }}</div>
								<div v-if="baseData.fax"><span>Fax:</span> {{ baseData.fax }}</div>
								<div v-if="baseData.email"><span>Email:</span> {{ baseData.email }}</div>
								<div v-if="baseData.website"><span>Website:</span> {{ baseData.website }}</div>
								<div><span>Kd.-Nr.:</span> {{ baseData.extRef }}</div>
							</div>

						</div>
						-->

						<!-- OPENING HOURS -->
						<div class="column is-6 bg-alternate">

							<div class="title">Öffnungszeiten für apothekenkatalog.at:</div>

							<template v-if="baseData.openingHours.length > 0">

								<div v-for="(value, index) in baseData.openingHours">

									<span class="dayInWeek">

										<template v-if="value.dayInWeek != null">
											<template v-if="index == 0">
												<lang :labelKey="'DAY_'+value.dayInWeek"></lang>:
											</template>
											<template v-else-if="value.dayInWeek != baseData.openingHours[index-1].dayInWeek">
												<lang :labelKey="'DAY_'+value.dayInWeek"></lang>:
											</template>
										</template>
									</span>
									<span>{{ formatDate(value.openTime) }} - {{ formatDate(value.closeTime) }}</span>

								</div>

							</template>

							<template v-else>

								keine Öffnungszeiten hinterlegt

							</template>

						</div>


						<!-- ORDERS -->
						<div class="column is-6 bg-alternate">

							<div class="title">Ihre Bestellung:</div>

							<div v-if="baseData.siteCatalogs[0].isSubscription == 1" id="aboBox">abo</div>

							<div v-if="baseData.siteCatalogs[0].quantity" class="ordersSection">

								<div style="font-size: 120%; margin: 0 0 5px 0;">
									{{ baseData.siteCatalogs[0].quantity }} Stk. <span v-if="baseData.siteCatalogs[0].rebateInKind">(+{{ baseData.siteCatalogs[0].rebateInKind }} Stk.)</span>
								</div>

								<div style="margin: 0 0 15px 0">
									{{ $t(packageName) }}
								</div>

							</div>

							<div v-else>
								keine Katalogbestellungen
							</div>

							<div v-if="baseData.siteCatalogs[0].hasShipment == true" class="ordersSection">

								<div class="heading">Versand:</div>
								<div>
									<span class="label">Empfängerliste:</span>{{ baseData.siteCatalogs[0].shipmentRecipientListQty}} Stk.
								</div>
								<div>
									<span class="label">Postwurfsendung:</span>{{ baseData.siteCatalogs[0].shipmentAreaQty }} Stk. <span v-if="baseData.siteCatalogs[0].shipmentAreaZipcodes">({{ baseData.siteCatalogs[0].shipmentAreaZipcodes }})</span>
								</div>

							</div>

							<div class="ordersSection">

								<div>
									<span class="label">Folieren:</span><template v-if="baseData.siteCatalogs[0].useFoilCoating != null">ja</template><template v-else>nein</template>
								</div>
								<div>
									<span class="label">POS-Material:</span><template v-if="baseData.siteCatalogs[0].promotionMaterialPackageQty != null">{{ baseData.siteCatalogs[0].promotionMaterialPackageQty }}</template><template v-else>-</template>
								</div>
								<div>
									<span class="label">Gutscheinboxen:</span><template v-if="baseData.siteCatalogs[0].couponBoxQty != null">{{ baseData.siteCatalogs[0].couponBoxQty }}</template><template v-else>-</template>
								</div>
								<div>
									<span class="label">zusätzliche Coupon Sets:</span><template v-if="baseData.siteCatalogs[0].couponSetQty != null">{{ baseData.siteCatalogs[0].couponSetQty }}</template><template v-else>-</template>
								</div>
							</div>

						</div>


						<!--
						<div class="column is-12" v-if="baseData.siteCatalogs[0].package != null">

							<button class="button is-pulled-right pointer" :key="showComments" @click="showComments=!showComments">
								<span class="icon is-small"><i class="icon-ak-bearbeiten"></i></span>
								<lang labelKey="APO-VIEW-EDIT_BASE_DATA"></lang>
							</button>

						</div>

						<div class="column is-12" v-show="showComments">
							<transition :name="showComments ? 'slide-fade-up' : 'slide-fade-down'">
								<comments :showHeader="false" :smallView="true" :headerTitle="APO_VIEW-HEADER_COMMENTS" :threadID.sync="baseData.thread" :api="'site/'+baseData.id"></comments>
							</transition>
						</div>
						-->

						<div class="column is-12">
							<transition :name="showComments ? 'slide-fade-up' : 'slide-fade-down'">
								<comments :showHeader="false" :smallView="true" :headerTitle="APO_VIEW-HEADER_COMMENTS" :threadID.sync="baseData.thread" :api="'site/'+baseData.id"></comments>
							</transition>
						</div>

					</div>

				</div>

			</div>


			<!-- BUTTONS -->
			<div class="column is-12" style="display: none;">

				<div class="buttons">

					<!-- approve button -->
					<div class="buttonContainer">
						<custom-button name="APO_VIEW-APPROVE_DATA" type="blue" icon="icon-ak-freigaben2" :loading="isApproving" :isDisabled="isDisabled" @click.native="approveData('approve')"></custom-button>
						<!-- <div class="additionalText"><lang labelKey="APO_VIEW-BTN-APPROVE-ADDITIONAL_TEXT"></lang></div> -->
					</div>

					<!-- print approve button -->
					<div class="buttonContainer">
						<custom-button name="APO_VIEW-PRINT_APPROVE_DATA" type="dark" icon="icon-ak-freigaben" :loading="isPrintApproving" :isDisabled="isDisabled" @click.native="approveData('printApprove')"></custom-button>
						<!-- <div class="additionalText"><lang labelKey="APO_VIEW-BTN-PRINT_APPROVE-ADDITIONAL_TEXT"></lang></div> -->
					</div>

				</div>


			</div>

		</div> <!-- // columns -->


		<div v-if="package != null" style="position: fixed; z-indx:9999; bottom: 0; left: 170px; right: 0; height: auto; padding: 25px 0; border-top: 1px solid #aaa; background: #f5f5f5;">

			<div class="buttons">

				<!-- approve button -->
				<div class="buttonContainer">
					<custom-button name="APO_VIEW-APPROVE_DATA" type="blue" icon="icon-ak-freigaben2" :loading="isApproving" :isDisabled="isDisabled" @click.native="approveData('approve')"></custom-button>
					<!-- <div class="additionalText"><lang labelKey="APO_VIEW-BTN-APPROVE-ADDITIONAL_TEXT"></lang></div> -->
				</div>

				<!-- print approve button -->
				<div class="buttonContainer">
					<custom-button name="APO_VIEW-PRINT_APPROVE_DATA" type="dark" icon="icon-ak-freigaben" :loading="isPrintApproving" :isDisabled="isDisabled" @click.native="approveData('printApprove')"></custom-button>
					<!-- <div class="additionalText"><lang labelKey="APO_VIEW-BTN-PRINT_APPROVE-ADDITIONAL_TEXT"></lang></div> -->
				</div>

			</div>

		</div>
	</template>
</div>




</div>
</template>


<script>
import comments from '../../utils/incl-comments';

export default {

	components: {
		comments
	},


	data() {

		return {
			isLoading: false,
			isApproving: false,
			isPrintApproving: false,
			showComments: false,
			baseData: [],
			mutations: [],
			package: {}
		}

	},

	created() {

		this.fetchData();

	},

	computed: {


		mutationList() {

			if(this.isSupplement) {

				return this.siteCatalogContentCategories.filter(_ => this.package.data.siteCatalogContentCategoriesSupplement.indexOf(_.id) != -1 && (_.name != 'CONTACT_CARD' || this.baseData.siteCatalogs[0].voucherPackage == null || this.baseData.siteCatalogs[0].voucherPackage == 10));
				// return this.siteCatalogContentCategories.filter(_ => this.package.data.siteCatalogContentCategoriesSupplement.indexOf(_.id) != -1 && (_.name == 'CONTACT_CARD' || (this.baseData.siteCatalogs[0].voucherPackage != null && this.baseData.siteCatalogs[0].voucherPackage == 10)));

			} else {

				return this.siteCatalogContentCategories.filter(_ => this.package.data.siteCatalogContentCategories.indexOf(_.id) != -1);

			}
		},


		siteCatalogContentCategories() {

			return Object.values(this.$store.getters.getTermsByTaxonomy('SITE_CATALOG_CONTENT_CATEGORIES'));
			// return Object.values(this.$store.getters.getTermsByTaxonomy('SITE_CATALOG_CONTENT_CATEGORIES_SUPPLEMENT'));

		},

		packageName() {

			let title = "";

			if(this.package && this.package != null) {
				title = 'APO_VIEW-TITLE-';
				title += this.isSupplement ? 'SUP-' : '';
				title += this.package.name+this.voucherType;
			} else {
				title = "-";
			}

			return title;

		},

		voucherType() {

			let type = "";

			if(this.baseData.siteCatalogs[0].voucherPackage) {
				// voucher package 3
				if(this.baseData.siteCatalogs[0].voucherPackage == 11) {
					type = "-3GS";
				}
				// voucher package 6
				else if(this.baseData.siteCatalogs[0].voucherPackage == 12) {
					type = "-6GS";
				}

			}

			return type;

		},

		isSupplement() {
			return this.$store.getters.getCurrentCatalog.hasCustomizationModeSupplement;
		},

		mutationAsset() {

			let url = "@/static/img/mutations/";
			let img = null
			let icon = null;

			// paket1: U1_U4
			// paket2: U1_U4_U2
			// paket3: U1_U4_U2_US

			let vouchers = "";

			if(this.baseData.siteCatalogs[0].voucherPackage) {

				// voucher package 3
				if(this.baseData.siteCatalogs[0].voucherPackage == 11) {
					vouchers = "-3gs";
				}
				// voucher package 6
				else if(this.baseData.siteCatalogs[0].voucherPackage == 12) {
					vouchers = "-6gs";
				}
			}


			switch(this.package.name) {

				// p1
				case "U1_U4":
					img = "img-p1"+vouchers+".jpg";
					icon = "icon-p1"+vouchers+".png";
					break;

				// p2
				case "U1_U4_U2":
					img = "img-p2"+vouchers+".jpg";
					icon = "icon-p2"+vouchers+".png";
					break;

				// p3
				case "U1_U4_U2_US":
					img = "img-p3"+vouchers+".jpg";
					icon = "icon-p3"+vouchers+".png";
					break;


				default:
					img = "img-p1"+vouchers+".jpg";
					icon = "icon-p1"+vouchers+".png";

			}

			return {
				'image': require(`@/assets/img/mutations/${img}`),
				'icon': require(`@/assets/img/mutations/${icon}`)
			}



		},

		isDisabled() {

			return ['NONE', 'APPROVAL_REQUESTED', 'PRINT_APPROVAL_REQUESTED', ].indexOf(this.baseData.siteCatalogs[0].status.name) == -1;

		},

		_infoText() {
 			return this.nl2br(this.$t('APO_VIEW-INFO_TEXT'));
		},

		siteCatalogStatus() {
			return this.$store.getters.getTermsByTaxonomy('SITE_CATALOG_STATUS');
		},

		siteCatalogCustomizations() {
			return this.$store.getters.getTermsByTaxonomy('SITE_CATALOG_CUSTOMIZATIONS');
		},

		logoUrl() {
			return this.$config.assets + this.baseData.logoAsset.path + '/' + this.baseData.logoAsset.filename;
		},

		/*
		getAbo() {

			if(this.baseData.siteCatalogs[0].package && this.baseData.siteCatalogs[0].package != null) {


				// get language string for packge id

				// switch(this.baseData.siteCatalogs[0].package.id) {
				// 	case 1:
				// 		mutation = this.$t('MUTATION_U1_U4'); break;
				// 	case 2:
				// 		mutation = this.$t('MUTATION_U1_U4_U2'); break;
				// 	case 3:
				// 		mutation = this.$t('MUTATION_U1_U4_U2_US'); break;
				// 	default: mutation = '';
				// }


				let mutation = this.$t('MUTATION_'+this.baseData.siteCatalogs[0].package.name);


				// check if there are any voucherPackages
				if(this.baseData.siteCatalogs[0].voucherPackage) {

					// voucher package 3
					if(this.baseData.siteCatalogs[0].voucherPackage == 11) {
						return mutation += " + 3 Gutscheine";
					}
					// voucher package 6
					else if(this.baseData.siteCatalogs[0].voucherPackage == 12) {
						return mutation += " + 6 Gutscheine";
					// default
					} else {
						return mutation;
					}

				// otherwise return package name only
				} else {
					return mutation;
				}

			} else {
				return "-";
			}

		}
		*/

	},

	methods: {

		getMutationTitle(mutation, index) {

			let title = 'APO_VIEW-CUSTOMIZATION-TITLE-';

			if(this.isSupplement) {
				title += 'SUP-';
			}

			if(mutation.name=='U1_U4' && index == 0) {
				return title += 'U1';
			}
			else if(mutation.name=='U1_U4' && index > 0) {
				return title += 'U4';
			}
			else if(mutation.name=='US' && index == 3) {
				return title += 'US_1';
			}
			else if(mutation.name=='US' && index > 3) {
				return title += 'US_2';
			}

			else {
				return title + mutation.name;
			}

		},


		getAsset(data) {

			if(data == null || data.preview == null) {
				return false;
			}

			return  this.$config.assets + data.preview.path + '/' + data.preview.filename;

        },

		getIconAsset(mutation, index) {

			if(mutation.name == 'U1_U4' && index == 0) {
				return '/static/img/mutation-icons/U1.png';
			}
			else if(mutation.name == 'U1_U4' && index > 0) {
				return '/static/img/mutation-icons/U4.png';
			}
			else if(mutation.name == 'U2') {

				return this.package.name == 'U1_U4_U2'
					? '/static/img/mutation-icons/P2-U2.png'
					: '/static/img/mutation-icons/P3-U2.png';

			}

			else if(mutation.name == 'US' && index == 3) {
				return '/static/img/mutation-icons/P3-1US.png';
			}
			else if(mutation.name == 'US' && index > 3) {
				return '/static/img/mutation-icons/P3-2US.png';
			}
			else if(mutation.name == 'VOUCHER') {

				if(this.package.name == 'U1_U4_U2' || this.package.name == 'U1_U4') {

					return mutation.id == 11
						? '/static/img/mutation-icons/P2-3-GUTSCHEINE.png'
						: '/static/img/mutation-icons/P2-6-GUTSCHEINE.png';

				} else {

					return mutation.id == 11
						? '/static/img/mutation-icons/P3-3-GUTSCHEINE.png'
						: '/static/img/mutation-icons/P3-6-GUTSCHEINE.png';

				}

			}


		},


		goToPage(mutation, index=0) {

			let url = "";

			if(mutation.name == 'VOUCHER') {

				url = '/voucher/';

			} else if(mutation.name == 'VOUCHERS') {

				url = '/voucher/';

			} else {

				let anchor = "";

				if(mutation.name=='U1_U4') {
					anchor = index == 0 ? "#U1" : "#U4";
				}

				else if(mutation.name == 'US') {
					anchor = index == 3 ? "#US_PAGE_1" : "#US_PAGE_2";
				}

				// url = '/content/'+this.baseData.siteCatalogs[0].id+'/'+mutation.name;
				url = '/content/'+mutation.name;

				if(anchor != "") {
					url += anchor;
				}

			}

			this.$router.push(url);

		},


		getPDFDownloadName(mutation) {

			let preview = mutation.preview;
			return this.baseData.extRef + '-' + preview.filename.split('.').shift().split('-').pop() + '.pdf';
		},

		getPDFDownloadNameVoucher(mutation) {

			let preview = mutation.preview;
			return this.baseData.extRef + '-' + preview.filename.split('.').shift().split('-').pop() + '.pdf';

		},

    getPDFDownloadUrl(mutation=null) {

			if(mutation == null || mutation.preview == null) {
				return false;
			}

			var asset = this.$config.assets + mutation.preview.path + '/' + mutation.preview.filename;
			// console.log("ASSET: ", asset);
			return asset.substr(0, asset.lastIndexOf(".")) + ".pdf";

    },

		getPdfDownloadUrlVoucher(type='front') {

			let catalog = this.baseData.siteCatalogs[0];

			if(type == "front") {

				if(catalog.voucherPreview == null) {
					return false;
				}

				var asset = this.$config.assets + catalog.voucherPreview.path + '/' + catalog.voucherPreview.filename;
				return asset.substr(0, asset.lastIndexOf(".")) + ".pdf";

			} else {

				if(catalog.voucherBackPreview == null) {
					return false;
				}

				var asset = this.$config.assets + catalog.voucherBackPreview.path + '/' + catalog.voucherBackPreview.filename;
				return asset.substr(0, asset.lastIndexOf(".")) + ".pdf";

			}


		},


		nl2br (str, is_xhtml) {
            var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
            return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
        },

		formatDate(date) {

			var tmp = date.split("T")[1];
			return tmp.substring(0, 5);

		},

		approveData(statusType) {

			let newStatus = statusType == 'printApprove'
			? this.siteCatalogStatus.PRINT_APPROVED
			: this.siteCatalogStatus.APPROVED

			if(statusType == 'printApprove') {
				this.isPrintApproving = true;
			} else {
				this.isApproving = true;
			}

			this.baseData.siteCatalogs[0].status = newStatus;


			this.axios.put(this.$config.api + 'siteCatalog/'+this.baseData.siteCatalogs[0].id, this.baseData.siteCatalogs[0])
			.then(res => {

				this.isApproving = this.isPrintApproving = false;

				let msg = statusType == 'printApprove'
					? this.$t('APO_VIEW-MSG-PRINT_APPROVEMENT_GRANTED')
					: this.$t('APO_VIEW-MSG-APPROVEMENT_GRANTED');

				this.$notify.success({ content: msg });

			})
			.catch(function(err) {
				this.isApproving = this.isPrintApproving = false;
				console.log(err);
			});

		},


		fetchData() {

			if(this.$store.getters.getUser.site == null) {
				return;
			}
			console.log("hier");

			this.isLoading = true;
			let url = this.$config.api + 'site/'+this.$store.getters.getUser.site.id+'?include=site.contactPerson,siteCatalog.status,site.logoAsset,site.openingHours,site.siteCatalogs,siteCatalog.package,siteCatalog.siteCatalogCustomizations,siteCatalogCustomization.preview,siteCatalog.voucherBackPreview,siteCatalog.voucherPreview&filters[siteCatalogs.catalog]='+this.catalogId;
			// url = this.$config.api + 'site/'+this.$store.getters.getUser.site+'?include=site.contactPerson,siteCatalog.status,site.logoAsset,site.openingHours,site.siteCatalogs,siteCatalog.package,siteCatalog.siteCatalogCustomizations,siteCatalogCustomization.preview,siteCatalog.voucherBackPreview,siteCatalog.voucherPreview&filters[siteCatalogs.catalog]='+this.catalogId;

			this.axios.get(url)
			.then(res => {

				this.baseData = res.data;

				var openingDates = [];
				['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'].forEach((weekDay) => {
					res.data.openingHours.forEach((date) => {
						if(date.dayInWeek == weekDay) {
							openingDates.push(date);
						}
					})
				})
				this.baseData.openingHours = openingDates;

				if(this.isSupplement) {

					this.package = res.data.siteCatalogs[0].package;

				} else {

					this.package = res.data.siteCatalogs[0].package;

					if(this.package != null) {

						var list = []

						switch(this.package.name) {
							case "U1_U4":
								list.push(this.siteCatalogCustomizations.U1_U4);
								list.push(this.siteCatalogCustomizations.U1_U4);
								break;

							case "U1_U4_U2":
								list.push(this.siteCatalogCustomizations.U1_U4);
								list.push(this.siteCatalogCustomizations.U1_U4);
								list.push(this.siteCatalogCustomizations.U2);
								break;

							case "U1_U4_U2_US":
								list.push(this.siteCatalogCustomizations.U1_U4);
								list.push(this.siteCatalogCustomizations.U1_U4);
								list.push(this.siteCatalogCustomizations.U2);
								list.push(this.siteCatalogCustomizations.US);
								list.push(this.siteCatalogCustomizations.US);
								break;
						}

						if(res.data.siteCatalogs[0].siteCatalogCustomizations.length > 0) {

							list.forEach(mut => {
								mut.data2 = res.data.siteCatalogs[0].siteCatalogCustomizations.find(cust => cust.type == mut.id);
								if(typeof mut.data2 == 'undefined') {
									mut.data2 = null;
								}
							});

						}

						// check if there are any voucherPackages
						if(res.data.siteCatalogs[0].voucherPackage == 11 || res.data.siteCatalogs[0].voucherPackage == 12 ) {

							list.push({
								name: 'VOUCHER',
								data2: {
									id: res.data.siteCatalogs[0].voucherPackage,
									preview: res.data.siteCatalogs[0].voucherPreview
								},
							})

						}

						this.mutations = list;

					}
				}

				this.isLoading = false;

			})
			.catch((err) => {

				this.isLoading = false;
				console.log(err);

			});

		}

	},

	/*
	beforeRouteLeave (to, from , next) {
		const answer = window.confirm('Do you really want to leave? you have unsaved changes!')

		if (answer) {
			next()
		} else {
			next(false)
		}

	},
	*/

}
</script>



<style lang="scss" scoped>

	#content-wrapper > div > .columns {
		padding-bottom: 200px;
	}

	.supplementPreview {

		.heading {
			display: flex;
			align-items: center;

			.previewIcon {
				max-width: 85px;
				margin: 0 8px 0 0;
			}

			span {
				letter-spacing: none;
				font-weight: bold;
			}
			h1 {
				font-size: 23px;
				font-weight: 600;
			}
		}

		img.previewImgBig {
			width: 100%;
			min-width: 480px;
			max-width: 768px;
		}
	}

	.ordersSection {

		.heading {
			font-size: 14px;
			text-transform: uppercase;
		}

	}



	.mutations {

		display: flex;
		flex-wrap: wrap;
		width: 100%;


		.mutation {

			padding: 40px 20px;
			width: 50%;
			border-bottom: 1px solid #eee;

			&:nth-child(odd) {
				border-right: 1px solid #eee;
			}

			&:last-child,
			&:nth-last-child(2) {
				border-bottom: none;
			}

			&.U1_U4 .preview {
				background-size: 200% auto;
				background-position: right top;
			}
			&.U1_U4:first-child .preview {
				background-position: 0 0;
			}

			&.U2 .preview {
				width: 262px;
			}
			&.US .preview {
				width: 239px;
				background-size: 200% auto;
				background-position: 0 0;
			}
			&.US.index-4 .preview {
				background-position: right top;
			}

			&.VOUCHER .preview {
				width: 134px;
				margin: 0;
				background-repeat: no-repeat;
				background-position: 50%;
				background-size: contain;
			}
			&.VOUCHER.VOUCHER-12 .preview {
				width: 225px;
			}

			.preview {
				width: 267px;
				height: 250px;
				cursor: pointer;
				background-repeat: no-repeat;
				background-position: 50% 50%;
				background-size: contain;
				-webkit-box-shadow: 0px 1px 8px 0px rgba(110,110,110,0.85);
				-moz-box-shadow: 0px 1px 8px 0px rgba(110,110,110,0.85);
				box-shadow: 0px 1px 8px 0px rgba(110,110,110,0.85);
				transition: box-shadow .3s ease;

				&:hover {
					-webkit-box-shadow: 0px 1px 8px 0px rgba(0,0,0,0.9);
					-moz-box-shadow: 0px 1px 8px 0px rgba(0,0,0,0.9);
					box-shadow: 0px 1px 8px 0px rgba(0,0,0,0.9)
				}


				&[lazy=loading] {
					background-size: 100px !important;
					background-position: 50% 50% !important;
					background-color: #FFF !important;
				}
				&[lazy=error] {
					background-size: 100px !important;
					background-position: 50% 50% !important;
					background-color: #FFF !important;
				}

			}

			.title {
				font-size: 18px;
				margin-bottom: 12px;
			}
			.options {
				margin-top: 12px;
				.button:not(:last-child) {
					margin-right: 6px;
				}
			}

			.imageIcon {
				background-repeat: no-repeat;
				background-position: left center;
				background-size: contain;
				width: 100%;
				height: 80px;
				margin-bottom: 20px;
			}

		}

		&.isSupplement {

			.mutation {

				.preview {
					width: 250px;
					background-repeat: no-repeat;
					background-position: 50%;
					background-size: contain;
				}
				&.VOUCHER {

					.column.first {
						display: flex !important;

						.preview {
							width: 118px;
							margin: 0;
							margin-right: 10px;
						}
					}
				}
				&.CONTACT_CARD .preview,
				&.RESPONSE_CONTACT_CARD .preview,
				&.RESPONSE_CARD_FRONT .preview,
				&.RESPONSE_CARD_BACK .preview {
					width: 118px;
					margin: 0;
				}

			}

		}

	}

	.buttons {

		display: flex;
		justify-content: center;
		padding: 0;

		.buttonContainer {
			max-width: 220px;
			display: block;
			margin: 0 10px;

			button.button {
				width: 220px;
			}
			.additionalText {
				margin-top: 5px;
				font-size: 13px;
				text-align: center;
			}

		}

	}
</style>

<style scoped>

	span.label {
		display: inline-block;
		width: 200px;
		font-weight: 300;
	}
	span.dayInWeek,
	.contactData span {
		display: inline-block;
		width: 70px;
	}
	span.dayInWeek {
		font-weight: 500;
	}
	.ordersSection {
		margin: 0 0 20px 0;
	}
	.logoContainer {
		width: auto;
		margin: 0 auto 15px auto;
	}
	.logoContainer img {
		max-height: 120px;
		max-width: 250px;
		height: auto;
		width: auto;
	}

	.successMsg.notification.alert {
		width: auto;
		min-width: 200px;
		float: right;
		padding: 8px 12px 8px 40px;
		font-size: 11px;
	}

	.boxBody {
		position: relative;
	}
	.boxBody #aboBox {
		position: absolute;
		right: 0;
		top: 0;
		width: 65px;
		height: 50px;
		background: #eee;
		color: #888;
		font-size: 18px;
		line-height: 50px;
		text-align: center;
		text-transform: uppercase;
	}

	.notification.is-info {
		background-color: #F2F2F2;
		color: red;
	}
	.notification.is-info >>> .notification-content p {
		margin-bottom: 1em !important;
	}

	.notification.is-info >>> .notification-content strong { color: inherit; }



	.infoText {
		margin: 25px auto;
		font-size: 18px;
		max-width: 850px;
	}


	.column.first {
		min-width: 280px;
	}
	.column.second {
		display: flex;
		flex-wrap: wrap;
		align-items: flex-end;
		padding-left: 25px;
	}

	@media all and (max-width: 890px) {

		.mutation {
			width: 100% !important;
			border-right: none !important;
			border-bottom: 1px solid #eee !important;
		}
		.mutation:last-child {
			border-bottom: none !important;
		}
		.column.second {
			padding-left: 15px;
		}

	}

	.column.second > div {
		width: 100%;
	}
	.myData .column {
		padding-right: 10px;
		padding-left: 10px;
	}
	.myData .title {
		font-size: 15px;
		font-weight: bold;
	}
	.myData .bg-alternate div:not(.title) {
		padding: 8px 20px;
	}
	.myData .bg-alternate div:nth-child(even):not(.title) {
		background: #f5f5f5;
	}
	.myData .ordersSection {
		padding: 0 !important;
	}


</style>
